import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * Descobre o IP da máquina na rede local via WebRTC (candidatos ICE) e o envia em todas as
 * requisições no header X-Client-Local-IP, para a trilha de auditoria do servidor.
 * É informativo: navegadores podem ocultar o IP (nome mDNS) e o valor pode ser forjado;
 * o IP público registrado pelo servidor é a evidência confiável.
 */
const CHAVE = 'local-ip';
const IP_PRIVADO = /^(10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.|169\.254\.)\d{1,3}(\.\d{1,3}){1,2}$/;
let ipLocal: string | null = null;
let descobrindo = false;

try {
  ipLocal = sessionStorage.getItem(CHAVE);
} catch {
  ipLocal = null;
}

function descobrirIpLocal() {
  if (ipLocal || descobrindo || typeof RTCPeerConnection === 'undefined') {
    return;
  }
  descobrindo = true;
  try {
    const conexao = new RTCPeerConnection({ iceServers: [] });
    conexao.createDataChannel('');
    conexao.onicecandidate = (evento) => {
      if (!evento.candidate) {
        conexao.close();
        descobrindo = false;
        return;
      }
      const m = /([0-9]{1,3}(?:\.[0-9]{1,3}){3})/.exec(evento.candidate.candidate);
      if (m && IP_PRIVADO.test(m[1])) {
        ipLocal = m[1];
        try {
          sessionStorage.setItem(CHAVE, ipLocal);
        } catch {
          // sem armazenamento: usa só em memória
        }
        conexao.onicecandidate = null;
        conexao.close();
        descobrindo = false;
      }
    };
    conexao.createOffer().then(oferta => conexao.setLocalDescription(oferta)).catch(() => {
      descobrindo = false;
    });
  } catch {
    descobrindo = false;
  }
}

descobrirIpLocal();

@Injectable()
export class LocalIpInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    descobrirIpLocal();
    if (ipLocal) {
      return next.handle(req.clone({ setHeaders: { 'X-Client-Local-IP': ipLocal } }));
    }
    return next.handle(req);
  }

}
